import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'

import { AppComponent } from './app.component'
import { AppRoutingModule } from './app-routing.module'
import { CoreModule, HttpService } from './core'
import { FooterComponent } from './footer/footer.component'
import { PublicHeaderComponent } from './public/public-header/public-header.component'
import { MaterialModule } from './shared/material/material.module'
//import {APP_BASE_HREF} from '@angular/common';
import { environment } from 'src/environments/environment'

import otlAngularConfig from '@vanguard/otl-angular-wrapper'
import {
  OpenTelemetryInterceptorModule,
  OtelColExporterModule,
  W3CTraceContextPropagatorModule
} from '@jufab/opentelemetry-angular-interceptor'
@NgModule({
  declarations: [AppComponent, PublicHeaderComponent, FooterComponent],
  imports: [BrowserModule, CommonModule, AppRoutingModule, CoreModule, BrowserAnimationsModule,MaterialModule,
    OpenTelemetryInterceptorModule.forRoot( otlAngularConfig({
      // substitute the following placeholders with your own application specific values
      serviceName: 'YY7-CCE-PUBLIC-UI',
      appPrefix: 'YY7', // you may also want to get this from the environment object, if present
      sysLevel:environment.SYS_LEVEL // or whatever key this value is stored under
  })),
    OtelColExporterModule, W3CTraceContextPropagatorModule],
  //providers: [HttpService, {provide: APP_BASE_HREF, useValue:'/'}],
  //providers: [HttpService, {provide: APP_BASE_HREF, useValue: environment.BASE_HREF}],
  //providers: [HttpService, {provide: APP_BASE_HREF, useValue:'dcrkpublic'}],
  providers: [HttpService],
  bootstrap: [AppComponent]
})
export class AppModule {}
